import {LandingNav, BuyerNav, AccountNav} from "./navs";

export const BUYER_OWNER_NAV = [
  LandingNav.SEARCH,
  AccountNav.LOCATIONS_BUYER_SUMMARY,
  BuyerNav.MY_BOOKINGS,
  {
    path: 'reports',
    label: 'Reports',
    submenus: [
      BuyerNav.BUYER_INVENTORY,
      BuyerNav.BUYER_INTERCHANGES,
      BuyerNav.BUYER_INVOICES,
      BuyerNav.BUYER_BOOKED_SPACE_CALENDAR,
      BuyerNav.BUYER_INVENTORY_CORRECTIONS,
    ]
  },
  LandingNav.RESOURCES_AS_BUYER,
  LandingNav.CONTACT
]

export const BUYER_DISPATCHER_NAV = [
  LandingNav.SEARCH,
  AccountNav.LOCATIONS_BUYER_SUMMARY,
  BuyerNav.MY_BOOKINGS,
  {
    path: 'reports',
    label: 'Reports',
    submenus: [
      BuyerNav.BUYER_INVENTORY,
      BuyerNav.BUYER_INTERCHANGES,
      BuyerNav.BUYER_INVOICES,
      BuyerNav.BUYER_BOOKED_SPACE_CALENDAR,
      BuyerNav.BUYER_INVENTORY_CORRECTIONS,
    ]
  },
  LandingNav.RESOURCES_AS_BUYER,
  LandingNav.CONTACT
]
